"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProtobufTimestamp = void 0;
const streem_sdk_protobuf_1 = require("streem-sdk-protobuf");
const getProtobufTimestamp = () => {
    const millis = new Date().getTime();
    return new streem_sdk_protobuf_1.Timestamp({
        seconds: new streem_sdk_protobuf_1.Long(millis / 1000),
        nanos: (millis % 1000) * 1e6,
    });
};
exports.getProtobufTimestamp = getProtobufTimestamp;
//# sourceMappingURL=get_protobuf_timestamp.js.map